import * as React from 'react';
//import {Input, Table, Grid, Dropdown, Menu} from 'semantic-ui-react';
import {RouteComponentProps} from 'react-router';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {Segment, Grid, Icon, Divider, Header, SemanticICONS, Breadcrumb} from 'semantic-ui-react';
import InfiniteScroll from 'react-infinite-scroller';
import LoadingContainer from "../../containers/LoadingContainer/LoadingContainer";
import FileService from "../../services/FileService";
import "./FileOverview.css";

import i18n from "../../../../locale/i18n";
import Moment from "react-moment";
import ErrorBox from "../../components/ErrorBox/ErrorBox";
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";
const translator = i18n.t.bind(i18n);

interface FileState {
    loading: Boolean,
    data: any,
    page: number,
    filter: String,
    sortColumn: string,
    sortDirection: "ascending" | "descending",
    section : string
}

class FileOverview extends React.Component<RouteComponentProps<{}>, FileState> {

    isLoading: Boolean = false;

    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            loading: true,
            page: 0,
            data: null,
            filter: "",
            sortColumn: "data.name",
            sortDirection: "descending",
            section: props.location.pathname.replace("/files/", "").replace("/", "")
        };

        this.props.history.listen((location, action) => {
            this.setState(
                {
                    section: location.pathname.replace("/files/", "").replace("/", "")
                }, this.reloadData.bind(this)
            );

        });

        this.handleInfinityScroll = this.handleInfinityScroll.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    reloadData() {
        let instance = this;

        FileService.getAllData(this.state.filter, this.state.section, i18n.language, 0, 12).then(
            function(data) {

                instance.setState(
                    {
                        data: data.data,
                        page: 0,
                        loading: false
                    }
                );

            }
        );

    }

    loadData() {
        let instance = this;

        let pageToLoad = this.state.page +1;
        let count = this.state.data.size;

        FileService.getAllData(this.state.filter, this.state.section, i18n.language, pageToLoad, count).then(
            function(data) {

                let newData = instance.state.data;

                newData.content = newData.content.concat(data.data.content);

                instance.setState( {
                    data: newData,
                    page: data.data.number
                }, () => { instance.isLoading = false});


            }
        );

    }

    downloadFile(objectId: any, name: string) {
        FileService.downloadFile(objectId, name);
    }

    handleInfinityScroll() {
        if (!this.isLoading) {
            this.isLoading = true;
            this.loadData();
        }
    }

    handleFilterChange(event: any) {
        this.setState({filter: event.target.value}, this.reloadData)
    }

    componentDidMount() {

        this.reloadData();
        ErrorBox.reset();
    }


    render() {

        let totalElements = 0;

        let FilePanels = null;

        if (this.state.data != null) {
            totalElements = this.state.data.totalElements;


            FilePanels = this.state.data.content.map((dataRow: any, idx: number) => {

                let fileIcon: SemanticICONS;

                switch (dataRow.contentType) {
                    case 'application/zip':
                        fileIcon = "file archive outline";
                        break;
                    case 'application/msexcel':
                        fileIcon = "file excel outline";
                        break;
                    case 'application/mspowerpoint':
                        fileIcon = "file powerpoint outline";
                        break;
                    case 'application/pdf':
                        fileIcon = "file pdf outline";
                        break;
                    case 'application/x-rar-compressed':
                        fileIcon = "file archive outline";
                        break;
                    default:
                        fileIcon = "file alternate outline";
                }


                return (
                    // TODO Columns are not wide enough on ipad pro with sidebar open, but semantic ui react has no proper distinction
                    //      iPad pro width/height is "computer" => same as larger screens.
                    //      replace with custom css media queries instead of width prop
                    <Grid.Column widescreen={4} largeScreen={4} computer={4} tablet={8} mobile={15} key={'file_' + idx}>
                            <Segment onClick={this.downloadFile.bind(this, dataRow.storedFileId, dataRow.filename)} className={"filePanel"}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column textAlign={"center"}>
                                            <Header icon>
                                                <Icon className={"icon"} name={fileIcon}/>
                                            </Header>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Divider className={"iconDivider"}
                                             horizontal>{dataRow.filename.split(".")[dataRow.filename.split(".").length-1]}</Divider>
                                    <Grid.Row className={"filePanelRow"}>
                                        <div>
                                            <p className="filePanel__filename text-primary">{dataRow.filename}</p>

                                            <Moment element={"p"} format={translator("Common.DateTimeFormat")}>
                                                {dataRow.updatedAt}
                                            </Moment>

                                            <p style={{opacity:0.8}}>{(dataRow.length /1024 /1024).toFixed(2) + "MiB"}</p>
                                        </div>
                                    </Grid.Row>
                                </Grid>

                            </Segment>
                    </Grid.Column>
                );
            });
        }


        return this.state.loading ? (
            <LoadingContainer showLogo={false}/>
        ) : (
            <>
                <AnalyticsTracking page={"documents" + (this.state.section ? '/' + this.state.section : '')} />
                <div className={"ui container"}>
                    <h3><Breadcrumb icon="right angle" sections={[
                        {key: '1', onClick: () => this.props.history.push("/files/"),
                            content: `${translator("Route.Files")}`, link: true}
                    ]} /></h3>
                    <p>{translator("FileOverview.Found%dFiles", {count: totalElements})}</p>
                </div>

                <InfiniteScroll
                    pageStart={0}
                    loadMore={this.handleInfinityScroll}
                    hasMore={this.state.data.totalPages > this.state.page}
                    threshold={100}
                    useWindow={false}
                    getScrollParent={() => ContentContainer.instance.componentRef.current as HTMLElement}
                    loader={<div key="IS_Loader" style={{width: "100%", textAlign: "center", marginTop:"30px"}}><LoadingSpinner key={0} /></div>}
                >
                    <Grid container columns={3}>
                        <Grid.Column>
                        </Grid.Column>
                        <Grid.Column>
                        </Grid.Column>
                        <Grid.Column>
                        </Grid.Column>
                    </Grid>
                    <Grid container stackable>
                            {FilePanels}
                    </Grid>
                </InfiniteScroll>
            </>
        );

    }
}

export default FileOverview;